<template>
    <div class="financialcashflow">
        <PageTitle
            icon="fa fa-search"
            main="Controle"
            sub="Fluxo de Caixa Financeiro"
        />
        <b-row class="mt-2">
            <div class="stats">
                <Stat
                    title="Saldo Anterior"
                    :value="this.total_plot_open"
                    color="#d54d50"
                />
                <Stat
                    title="Saldo no Período"
                    :value="this.total_plot_closed"
                    color="#3bc480"
                />
                <Stat title="Total" :value="this.total_plot" color="#3282cd" />
            </div>
        </b-row>
        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="release-search-start_date"
                >
                    <b-form-input
                        id="release-search-start_date"
                        type="date"
                        v-model="start_date"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="release-search-end_date"
                >
                    <b-form-input
                        id="release-search-end_date"
                        type="date"
                        v-model="end_date"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="4" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="release-search-company_id"
                >
                    <b-form-select
                        id="release-search-company_id"
                        @input=";[loadReleases(), loadHeadFlow()]"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Realizado:"
                    label-for="release-search-closed"
                >
                    <b-form-select
                        id="release-search-closed"
                        size="sm"
                        @input=";[loadReleases(), loadHeadFlow()]"
                        :options="questionboxyesnoalls"
                        v-model="closed"
                    />
                </b-form-group>
            </b-col>
            <b-col md="1" sm="12">
                <b-link
                    @click=";[loadHeadFlow(), loadReleases()]"
                    class="fa fa-search mt-4"
                ></b-link>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        class="table-responsive"
                        sticky-header
                        head-variant="light"
                        hover
                        key="slide"
                        striped
                        :items="flow"
                        :fields="fields"
                    >
                    </b-table>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Stat from '../home/Stat'
var moment = require('moment')

export default {
    name: 'FinancialCashFlowSearch',
    components: { PageTitle, Stat },
    data: function() {
        return {
            financialcashflows: [],
            total_plot_closed: 0,
            total_plot_open: 0,
            total_plot: 0,
            closed: null,
            start_date: null,
            end_date: null,
            company_id: null,
            companys: [],
            flow: [],
            questionboxyesnoalls: [
                { text: 'Sim', value: 1 },
                { text: 'Não', value: 2 }
            ],
            cost_center_id: null,
            costcenters: [],
            showTable: false,
            fields: [
                {
                    key: 'due_date',
                    label: 'Data',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'saldo_old',
                    label: 'Saldo Anterior',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_payment',
                    label: 'Despesa',
                    sortable: false,
                    variant: 'danger',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_receip',
                    label: 'Receita',
                    sortable: false,
                    variant: 'success',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'saldo_day',
                    label: 'Saldo Dia',
                    sortable: false
                },
                {
                    key: 'saldo_current',
                    label: 'Saldo Acumulado',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                }
            ]
        }
    },
    computed: {
        compan() {
            return this.$store.state.compan
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        }
    },
    methods: {
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        loadReleases() {
            let url = null
            this.flow = null

            if (this.closed == 1) {
                url = `${baseApiUrl}/financialcashflowsdetailclosed/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&cost_center_id=${this.cost_center_id}`
            } else {
                url = `${baseApiUrl}/financialcashflowsdetail/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&cost_center_id=${this.cost_center_id}`
            }

            axios.get(url).then(res => {
                this.flow = res.data[0]
            })
        },
        async loadHeadFlow() {
            let url = null
            this.total_plot_open = 0
            this.total_plot_closed = 0
            this.total_plot = 0

            if (this.closed == 1) {
                url = `${baseApiUrl}/financialcashflowsclosed/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&cost_center_id=${this.cost_center_id}`
            } else {
                url = `${baseApiUrl}/financialcashflows/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&cost_center_id=${this.cost_center_id}`
            }
            await axios.get(url).then(res => {
                this.total_plot_open = this.formatPrice(res.data[0])
                this.total_plot_closed = this.formatPrice(res.data[1])
                this.total_plot = this.formatPrice(res.data[2])
            })
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        }
    },
    mounted() {
        this.loadCompanys()
        //this.loadReleases()
        this.showTable = true
        let date = new Date()
        let fist_day_month = new Date(date.getFullYear(), date.getMonth(), 1)
        let Last_day_month = new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            0
        )
        this.start_date = this.formatDate(fist_day_month)
        this.end_date = this.formatDate(Last_day_month)
    }
}
</script>

<style>
.financialcashflow {
    font-size: 0.7rem;
}

.financialcashflow input,
label,
form {
    font-size: 0.7rem;
}
.financialcashflow button {
    font-size: 0.7rem;
}

.financialcashflow select {
    font-size: 0.7rem;
}

.financialcashflow table {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
